import { LoadingOverlay } from "../../../../shared/ui/common/LoadingOverlay";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { useSubscription } from "../../application/useSubscription";
import SubscriptionRestrictedState from "../../../../shared/ui/common/SubscriptionRestrictedState";

export default function SubscriptionRouteGuard() {
    const { isPremium, loading } = useSubscription();
    const { t } = useTranslation();

    if (loading) return <LoadingOverlay visible={true} message={t("common.loading")} />;

    if (!isPremium) {
        // Option 1: Redirect to subscription page
        // return <Navigate to="/subscription" replace />;

        // Option 2: Show restricted state directly (User preference seems to imply blocking, but showing the UI is nicer)
        // However, if we want to BLOCK access to the logic/page entirely as requested ("Block ... urls"), 
        // we can either show the restricted component or redirect. 
        // Let's show the restricted component to be consistent with the page-level restriction we did before, 
        // but this guard prevents the nested routes from even rendering their own components.
        return (
            <div className="p-6">
                <SubscriptionRestrictedState />
            </div>
        );
    }

    return <Outlet />;
}
